import { createFileRoute } from '@tanstack/react-router';
import {
  loadUserGroupMessages,
  loadUserGroupScreens,
  userGroupListScreen,
  userGroupListSearch,
} from '@/modules/user-group/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/seguranca/grupos/')({
  validateSearch: userGroupListSearch,
  staticData: { screen: userGroupListScreen },
  loader: () => loadUserGroupMessages(),
  component: lazyScreen(loadUserGroupScreens, 'UserGroupListScreen'),
});
